<template>
  <div class="video video-box">
    <video
      id="myVideo"
      controls
      loop
      :src="src"
      :poster="poster"
    ></video>
    <div class="video-function"
         :class="{'is-show': videoLoadingStatus && !videoPayStatus}"
         v-if="videoLoadingStatus">
      <div class="video-button"
           v-if="videoPayStatus"
           @click="pauseVideo">
        <el-icon class="el-icon-video-pause"></el-icon>
      </div>
      <div class="video-button"
           v-else
           @click="playVideo">
        <el-icon class="el-icon-video-play"></el-icon>
      </div>
    </div>
  </div>
</template>

<script>
import {myVideo} from "@common/videoBox/video";

export default {
  name: "videoBox",
  mixins:[myVideo],
  props:{
    poster:{
      type:String,
      default: '',
    },
    src:{
      type:String,
      default:"https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/video/new_video.mp4",
    },
    controls:{
      type:Boolean,
      default:true,
    },
    loop:{
      type:Boolean,
      default:true,
    },
  },
}
</script>

<style scoped lang="scss">
.video-box {
  //width: 400px;
  //height: 320px;
  //margin-right: 20px;
}
/* 视频 start*/
.video{
  position: relative;
  $buttonWidth:100px;
  video{
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: black;
    //object-fit: fill
  }
  .video-function{
    display: none;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    /*bottom: 0;*/
    /*height: 0;*/
    width: $buttonWidth;
    height: $buttonWidth;
    margin-top: -($buttonWidth/2);
    margin-left: -($buttonWidth/2);
    //background-color: rgba(0,0,0,0.3);
    &.is-show{
      display: block;
    }
  }
  &:hover .video-function{
    display: block;
  }
  .video-button{
    //position: absolute;
    //z-index: 2;
    //top: 50%;
    //left: 50%;
    //margin-left: -50px;
    //margin-top: -50px;
    width: $buttonWidth;
    height: $buttonWidth;
    line-height: $buttonWidth;
    cursor: pointer;
    font-size: $buttonWidth * 0.9;
    text-align: center;
    color: white;
  }
}
/* 视频 end*/
</style>



// WEBPACK FOOTER //
// common/videoBox/index.vue